import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { DataTieringRepositories } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { REPOSITORIES_SUMMARY_QUERY_KEY } from "../constants";
const NO_SESSION_EXT = { requestShouldExtendSession: false };
const translate = (key) => i18n.t(key, { ns: "enterprise_data_tiering" });
const fetchSummary = () => DataTieringRepositories.allRepositories(void 0, NO_SESSION_EXT).then(
  (states) => states.map((state) => ({ ...state, repository: state.repository }))
);
const hasCredentialProblem = ({ credential_status }) => credential_status === "missing" || credential_status === "invalid";
const useRepositoriesSummary = ({ refetchInterval } = {}) => {
  var _a, _b;
  const { data, isLoading, isError } = useQuery({
    queryKey: REPOSITORIES_SUMMARY_QUERY_KEY,
    queryFn: () => defaultOnError(
      fetchSummary(),
      translate("notifications.summary_loading_failed"),
      translate("notifications.summary_could_not_load")
    ),
    refetchInterval: refetchInterval || void 0
  });
  return {
    summary: {
      data,
      isLoading,
      isError
    },
    configuredCount: (_a = data == null ? void 0 : data.length) != null ? _a : 0,
    credentialProblemsCount: (_b = data == null ? void 0 : data.filter(hasCredentialProblem).length) != null ? _b : 0
  };
};
export default useRepositoriesSummary;
